import useAuth from '@hooks/useAuth'
import React from 'react'
import Empty from './components/Empty'
import Member from './components/Member'
import Owner from './components/Owner'

export default function ClubPage() {
    const { user } = useAuth<Resources.Customer>()

    if (user.club)
        return <Owner />
    else if (user.membership)
        return <Member />
    else
        return <Empty />
}